<template>
  <div class="canvas-line-question-view">
<!--    <div class="question-desc-view">{{questioninfo.desc}}</div>-->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="question-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div id="box" class="canvas-line-question-info-view">
      <div class="canvas-lines-question-content-info-view">
        <template v-for=" (leftitem,index) in questioninfo.leftcontents">
          <div :id="'linesentenceleft'+index" class="sentence-left-item-view" :data-sort="index"
               :data-choseitem="leftitem" @click="clickleft($event)">
            {{leftitem}}
          </div>
        </template>
      </div>
      <div class="canvas-lines-question-content-info-view">
        <template v-for=" (rigthitem,index) in questioninfo.rightcontents">
          <div :id="'linesentenceright'+index" class="sentence-right-item-view" :data-sort="index"
               :data-choseitem="rigthitem"
               @click="clickright($event)">{{rigthitem}}
          </div>
        </template>
      </div>
      <canvas id="myCanvas"></canvas>
    </div>
    <audio ref="linemusic" controls="controls" style="display: none"
           preload="auto">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';

  export default {
    name: "canvaslinequestion",
    data() {
      return {
        baseurl: apiUtil.getBaseUrl(),
        questioninfo: {},
        showanswer: false,
        ctx: null,
        leftclick: [],
        rightclick: [],
        lineArr: [],
        ctx1: null,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        showdesc: true,
        audiourl: "",
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.linemusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(this.questionData);
        setTimeout(() => {
          this.initCanvas()
        })
      },
      initCanvas() {
        var c = document.getElementById("myCanvas");
        c.width = document.getElementById("box").clientWidth;
        c.height = document.getElementById("box").clientHeight;
        this.ctx = c.getContext("2d");
        if (this.questioninfo.useroption && this.questioninfo.useroption.length > 0) {
          this.drawuseroption()
        }
      },
      drawuseroption() {
        var leftitems = document.getElementsByClassName("sentence-left-item-view")
        var rightitems = document.getElementsByClassName("sentence-right-item-view")
        this.questioninfo.useroption.forEach(item => {
          var leftitem = null
          var rightitem = null
          for (var i = 0; i < leftitems.length; i++) {
            if (leftitems[i].innerText == item[0]) {
              leftitem = leftitems[i]
            }
          }
          for (var j = 0; j < rightitems.length; j++) {
            if (rightitems[j].innerText == item[1]) {
              rightitem = rightitems[j]
            }
          }
          var line = {
            linecolor: "black",
            index: [leftitem.dataset.sort, rightitem.dataset.sort],
            array: [leftitem.dataset.choseitem, rightitem.dataset.choseitem],
            left: {
              x: leftitem.offsetLeft + leftitem.offsetWidth - 5,
              y: leftitem.offsetTop + leftitem.offsetHeight / 2
            },
            right: {
              x: rightitem.offsetLeft - 5,
              y: rightitem.offsetTop + rightitem.offsetHeight / 2
            }
          }
          var hasindex = this.ishavearr(this.lineArr, line)
          if (hasindex != -1) {
            this.lineArr.splice(hasindex, 1)
          } else {
            this.lineArr.push(line)
          }
          this.drawLine("myCanvas", this.ctx, this.lineArr)
        })
      },
      paraseData(questionData) {
        console.log("parase")
        var questiondata = {};
        if (!questionData.useroption) {
          var leftcontents = questionData.content.split("|")
          var answersinfo = questionData.answer.split("&");
          var answers = []
          var rightcontents = questionData.options.split("|")
          answersinfo.forEach(item => {
            var answerinfoitem = item.split("|");
            if (answerinfoitem.length > 2) {
              for (var i = 0; i < answerinfoitem.length - 1; i++) {
                var arr = [answerinfoitem[i], answerinfoitem[answerinfoitem.length - 1]]
                answers.push(arr)
              }
            } else {
              answers.push(answerinfoitem)
            }
          })
          questiondata.leftcontents = this.randomSort(leftcontents);
          questiondata.rightcontents = this.randomSort(rightcontents);
          questiondata.answers = answers;
          questiondata.content = questionData.content;
          questiondata.options = questionData.options;
          questiondata.question_type = questionData.question_type;
          questiondata.show_type = questionData.show_type;
          questiondata.desc = questionData.desc;
          questiondata.id = questionData.id;
          questiondata.exaquestion_id=questionData.exaquestion_id;
          questiondata.score=questionData.score;
          questiondata.reading_time = questionData.reading_time;
          questiondata.answer_time = questionData.answer_time;
          questiondata.content_audio = questionData.content_audio;
              this.$emit("questionfinish", questiondata)
        } else {
          questiondata = questionData
        }

        console.log(questiondata)
        return questiondata;
      },

      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
          console.log(elements.className)
        }
      },
      clickleft(ev) {
        var isclick = false;
        var index = ev.target.dataset.sort
        var leftitems = document.getElementsByClassName("sentence-left-item-view")
        for (var i = 0; i < leftitems.length; i++) {
          var leftitem = leftitems[i];
          if (i == index) {
            if (!this.hasClass(leftitem, "click")) {
              this.addClass(leftitem, "click")
              isclick = true;
            } else {
              this.removeClass(leftitem, "click")
            }
          } else {
            this.removeClass(leftitem, "click")
          }
        }
        var haschick = this.checkClick("sentence-right-item-view");
        if (haschick && isclick) {
          this.isCanClick = true;
          this.checkArr();
        }
      },
      clickright(ev) {
        var isclick = false;
        var index = ev.target.dataset.sort
        var rightitems = document.getElementsByClassName("sentence-right-item-view")
        for (var i = 0; i < rightitems.length; i++) {
          var rightitem = rightitems[i];
          if (i == index) {
            if (!this.hasClass(rightitem, "click")) {
              this.addClass(rightitem, "click")
              isclick = true;
            } else {
              this.removeClass(rightitem, "click")
            }
          } else {
            this.removeClass(rightitem, "click")
          }
        }
        var haschick = this.checkClick("sentence-left-item-view");
        console.log("right", haschick)
        if (haschick) {
          this.isCanClick = true;
          this.checkArr();
        }
      },
      checkClick(dom) {
        var hasclick = false
        var items = document.getElementsByClassName(dom);
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (this.hasClass(item, "click")) {
            hasclick = true
          }
        }
        return hasclick;
      },
      checkArr() {
        var leftitems = document.getElementsByClassName("sentence-left-item-view")
        var rightitems = document.getElementsByClassName("sentence-right-item-view")
        var leftitem = null
        var rightitem = null
        for (var i = 0; i < leftitems.length; i++) {
          if (this.hasClass(leftitems[i], "click")) {
            leftitem = leftitems[i]
          }
        }
        for (var j = 0; j < rightitems.length; j++) {
          if (this.hasClass(rightitems[j], "click")) {
            rightitem = rightitems[j]
          }
        }
        var line = {
          linecolor: "black",
          index: [leftitem.dataset.sort, rightitem.dataset.sort],
          array: [leftitem.dataset.choseitem, rightitem.dataset.choseitem],
          left: {
            x: leftitem.offsetLeft + leftitem.offsetWidth - 5,
            y: leftitem.offsetTop + leftitem.offsetHeight / 2
          },
          right: {
            x: rightitem.offsetLeft - 5,
            y: rightitem.offsetTop + rightitem.offsetHeight / 2
          }
        }
        var hasindex = this.ishavearr(this.lineArr, line)
        if (hasindex != -1) {
          this.lineArr.splice(hasindex, 1)
        } else {
          this.lineArr.push(line)
        }
        this.checkanswer()
        this.drawLine("myCanvas", this.ctx, this.lineArr)
        for (var i = 0; i < leftitems.length; i++) {
          if (this.hasClass(leftitems[i], "click")) {
            this.removeClass(leftitems[i], "click")
          }
        }
        for (var j = 0; j < rightitems.length; j++) {
          if (this.hasClass(rightitems[j], "click")) {
            this.removeClass(rightitems[j], "click")
          }
        }
      },
      drawLine(id, ctx, lineArr) {
        var c = document.getElementById(id);
        ctx.clearRect(0, 0, c.clientWidth, c.clientHeight);
        for (let i = 0; i < lineArr.length; i++) {
          ctx.beginPath();
          ctx.strokeStyle = lineArr[i].linecolor;
          ctx.lineCap = "round";
          ctx.lineWidth = "3";
          ctx.moveTo(lineArr[i].left.x + 5, lineArr[i].left.y + 5);
          ctx.lineTo(lineArr[i].right.x + 5, lineArr[i].right.y + 5);
          ctx.stroke();
        }
      },
      ishavearr(arr, value) {
        var flag = -1;
        if (arr.length > 0) {
          arr.forEach((item, index) => {
            if (item.left.x == value.left.x && item.left.y == value.left.y && item.right.x == value.right.x && item.right.y == value.right.y) {
              flag = index;
            }
          })
        }
        return flag
      },
      checkanswer() {
        var that = this;
        var useroption = []
        var isfinish = true
        if (this.lineArr.length > 0) {
          this.lineArr.forEach(item => {
            useroption.push(item.array)
          })
        } else {
          isfinish = false
        }
        this.questioninfo.useroption = useroption
        this.questioninfo.isfinish = isfinish
        this.$emit("questionfinish", this.questioninfo)
      },

      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.linemusic.src = audiourl;
        if (this.$refs.linemusic.paused) {
          this.$refs.linemusic.play()
          this.contentplay = true;
        }
      },
      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .canvas-line-question-view {
    width 100%;
    height 100%;
  }

  .canvas-line-question-info-view {
    display flex;
    width 100%;
    flex 1;
    background #fff;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
  }

  .canvas-line-question-info-view1 {
    display flex;
    width 100%;
    height 100%;
    background #FFF;
    position relative;
    display flex;
    justify-content space-around;
    align-items center;
    border-radius 12px;

    .canvas-lines-sentence-question-content-info-view1 {
      width 50%;
      height 100%;
      margin 10px auto;
      display flex;
      flex-direction column;
      align-items center;
      justify-content space-around;
    }

    #myCanvas1 {
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      top: 0;
      left: 0;
    }

    .sentence-right-item-view1 {
      width 70%;
      font-size 28px;
      padding 5px 0;
      margin 5px;
      border 3px solid #000;
      border-radius: 12px;
    }

    .sentence-left-item-view1 {
      width 70%;
      font-size 28px;
      padding 5px 0;
      margin 5px;
      border 3px solid #000;
      border-radius: 12px;
    }
  }

  .click {
    background #5874F8;
    border 3px solid #5874F8;
  }

  .el-sentence-top-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-up-btn.png");
    background-size 100% 100%;
  }

  .el-left-sentence-btn {
    position absolute;
    left 15px;
    display flex;
    flex-direction column;
  }

  .el-right-sentence-btn {
    position absolute;
    right 15px;
    display flex;
    flex-direction column;
  }

  .el-sentence-bottom-btn {
    width 38px;
    height 38px;
    background url("../../assets/img/el-down-btn.png");
    background-size 100% 100%;
  }

  .canvas-lines-question-content-info-view {
    width 50%;
    height 90%;
    margin 10px auto;
    display flex;
    flex-direction column;
    align-items center;
    justify-content space-around;
  }

  .sentence-right-item-view1 {
    width 70%;
    font-size 28px;
    padding 5px 0;
    margin 5px;
    border 3px solid #000;
    border-radius: 12px;
  }

  .sentence-left-item-view1 {
    width 70%;
    font-size 28px;
    padding 5px 0;
    margin 5px;
    border 3px solid #000;
    border-radius: 12px;
  }

  #myCanvas {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  .sentence-right-item-view {
    width 70%;
    font-size 28px;
    padding 5px 0;
    margin 5px;
    border 3px solid #000;
    border-radius: 12px;
  }

  .sentence-left-item-view {
    width 70%;
    font-size 28px;
    padding 5px 0;
    margin 5px;
    border 3px solid #000;
    border-radius: 12px;
  }

  .line-sentence-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .line-sentence-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .line-sentence-finish-view {
      width 100%;
      height 90px;
      display flex;
      position absolute;
      bottom 0;
    }

    .line-sentence-answer-right-bottom-view img {
      margin-right 15px;
    }

    .line-sentence-answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #92C761;
    }

    .line-sentence-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .line-sentence-answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 36px;
        background #F45578;
      }

      .line-sentence-answer-wrong-bottom-view img {
        margin-right 15px;
      }
    }
  }

  .line-sentence-show-answer-btn {
    font-size 24px;
    color #fff;
    padding 0 15px;
    display flex;
    height 100%;
    flex-direction column;
    justify-content center;
    align-items center;
    background #92C761;
  }

  .line-sentence-show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 2000;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
    z-index 11;
  }

  .line-sentence-show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    font-size 36px;
    text-align left;
    line-height 50px;
  }

  @media screen and (max-width: 1600px) {
    .canvas-line-question-info-view {
      display flex;
      width 88.54%;
      height 75%;
      position relative;
      left 5.73%;
      top -6%;
      border-radius 12px;
    }

    .sentence-left-item-view {
      font-size 18px;
    }

    .sentence-right-item-view {
      font-size 18px;
    }

    .prev-btn {
      position absolute;
      left 1%;
      top 50%;
      font-size 24px;
    }

    .next-btn {
      position absolute;
      right 1%;
      top 50%;
      font-size 24px;
    }

    .line-sentence-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .line-sentence-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .line-sentence-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        justify-content center;
        align-items center;
        font-size 24px;
        color #F5C55D;
        bottom 0;

        .line-sentence-answer-wrong-bottom-view {
          font-size 24px;
        }

        .line-sentence-answer-right-bottom-view {
          font-size 24px;
        }
      }

      .line-sentence-finish-view img {
        width: 40px;
        height 40px;
        background-size 100% 100%;
      }

      .line-sentence-show-answer-btn {
        font-size 18px;
      }

      .line-sentence-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .canvas-line-question-info-view {
      display flex;
      width 88.54%;
      height 81%;
      position relative;
      left 5.73%;
      top -15%;
      border-radius 12px;
    }

    .sentence-left-item-view {
      font-size 18px;
    }

    .sentence-right-item-view {
      font-size 18px;
    }

    .prev-btn {
      position absolute;
      left 1%;
      top 50%;
      font-size 24px;
    }

    .next-btn {
      position absolute;
      right 1%;
      top 50%;
      font-size 24px;
    }

    .line-sentence-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .line-sentence-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 36px;
        background #5777FF;
        color #fff;
      }

      .line-sentence-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        justify-content center;
        align-items center;
        font-size 24px;
        color #F5C55D;
        bottom 0;

        .line-sentence-answer-wrong-bottom-view {
          font-size 24px;
        }

        .line-sentence-answer-right-bottom-view {
          font-size 24px;
        }
      }

      .line-sentence-finish-view img {
        width: 40px;
        height 40px;
        background-size 100% 100%;
      }

      .line-sentence-show-answer-btn {
        font-size 18px;
      }

      .line-sentence-show-answer-btn img {
        width 20px;
        height 20px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/public/canvaslinequestion.vue